$(function () {
    var blockClass = 'home-slider';
    var dot = '.';

    var carouselClass = blockClass + '__carousel';
    var prevClass = blockClass + '__previous';
    var nextClass = blockClass + '__next';

    $(dot + carouselClass).each(function (carouselIndex, carouselElement) {
        var parent = $(carouselElement).parent();
        var prev = parent.find(dot + prevClass);
        var next = parent.find(dot + nextClass);

        var options = {
            container: carouselElement,
            nav: true,
            navContainer: ".home-slider__buttons",
            controls: true,
            controlsContainer: ".home-slider__control",
            autoplay: true,
            autoplayButtonOutput: false,
            autoplayHoverPause: true,
            autoplayTimeout: 8000,
            speed: 400
        };

        if (prev.length !== 0) {
            options.prevButton = prev.get(0);
        }

        if (next.length !== 0) {
            options.nextButton = next.get(0);
        }

        var slider = tns(options);
    });

    $('.home-slider .--no-js').removeClass('--no-js');

});

/////////////////////////////////////////////////////////////

$(function () {
    var blockClass = 'logo-slider';
    var dot = '.';

    var carouselClass = blockClass + '__carousel';
    var prevClass = blockClass + '__previous';
    var nextClass = blockClass + '__next';

    $(dot + carouselClass).each(function (carouselIndex, carouselElement) {
        var parent = $(carouselElement).parent();
        var prev = parent.find(dot + prevClass);
        var next = parent.find(dot + nextClass);

        var optionsLogo = {
            container: carouselElement,
            loop: true,
            items: 3,
            slideBy: 'page',
            nav: true,
            navContainer: ".logo-slider__buttons",
            autoplay: true,
            autoplayTimeout: 5500,
            speed: 400,
            autoplayButtonOutput: false,
            mouseDrag: true,
            controls: true,
            controlsContainer: ".logo-slider__control",
            responsive: {
                0: {
                    nav: false,
                    items: 3,
                },
                960: {
                    nav: true,
                    items: 6,
                }
            }
        };

        if (prev.length !== 0) {
            optionsLogo.prevButton = prev.get(0);
        }

        if (next.length !== 0) {
            optionsLogo.nextButton = next.get(0);
        }

        var slider = tns(optionsLogo);
    });

    $('.logo-slider .--no-js').removeClass('--no-js');
});

//////////////////////////////////////////////////////

$(function () {
    var blockClass = 'flex-slider';
    var dot = '.';

    var carouselClass = blockClass + '__carousel';
    var prevClass = blockClass + '__previous';
    var nextClass = blockClass + '__next';

    $(dot + carouselClass).each(function (carouselIndex, carouselElement) {
        var parent = $(carouselElement).parent();
        var prev = parent.find(dot + prevClass);
        var next = parent.find(dot + nextClass);

        var options = {
            container: carouselElement,
            nav: true,
            navContainer: ".flex-slider__buttons",
            navPosition: "bottom",
            controls: true,
            controlsContainer: ".flex-slider__control",
            //controlsPosition: "top";
            autoplay: false,
            autoplayButtonOutput: false,
            autoplayHoverPause: true,
            autoplayTimeout: 8000,
            speed: 400
        };

        if (prev.length !== 0) {
            options.prevButton = prev.get(0);
        }

        if (next.length !== 0) {
            options.nextButton = next.get(0);
        }

        var slider = tns(options);
    });
    $('.flex-slider .--no-js').removeClass('--no-js');
});